import { ReactNode } from "react";
import { SortIcon } from "../atoms/SortIcon";
import { SortField, SortDirection } from "../../types/dashboard";

interface SortableHeaderProps {
  label: string;
  sublabel?: string;
  field: SortField;
  sortField: SortField | null;
  sortDirection: SortDirection;
  onSort: (field: SortField) => void;
  icon?: ReactNode;
}

export function SortableHeader({
  label,
  sublabel,
  field,
  sortField,
  sortDirection,
  onSort,
  icon,
}: SortableHeaderProps) {
  return (
    <button
      type="button"
      onClick={() => onSort(field)}
      className="group flex items-center justify-center gap-1 hover:text-foreground transition-colors cursor-pointer bg-transparent border-none p-0"
    >
      {icon}
      <div className="flex flex-col items-center">
        <span className="text-[11px] font-medium text-muted-foreground leading-tight whitespace-nowrap">
          {label}
        </span>
        {sublabel && (
          <span className="text-[10px] italic text-muted-foreground whitespace-nowrap">
            {sublabel}
          </span>
        )}
      </div>
      <SortIcon field={field} sortField={sortField} sortDirection={sortDirection} />
    </button>
  );
}
